import { configureStore } from '@reduxjs/toolkit';

// Import all the slice reducers
import bookmarkCardsReducer from '../slices/bookmarkCardsSlice';
import bookmarkFilterReducer from '../slices/bookmarkFilterSlice';
import bookmarkModalReducer from '../slices/bookmarkModalSlice';
import favouriteFilterReducer from '../slices/favouriteFilterSlice';
import feedbackModalReducer from '../slices/feedbackModalSlice';
import languageReducer from '../slices/languageSlice';
import loadingReducer from '../slices/loadingSlice';
import messageQueueReducer from '../slices/messageQueueSlice';
import mobileViewReducer from '../slices/mobileViewSlice';
import myFavouritesReducer from '../slices/myFavouritesSlice';
import showSiteFavOnlyReducer from '../slices/showSiteFavOnlySlice';
import siteFavouritesReducer from '../slices/siteFavouritesSlice';
import userReducer from '../slices/userSlice';
import listLoaderReducer from '../slices/listLoaderSlice';
import cardsLoaderReducer from '../slices/cardsLoaderSlice';

// Enable Redux DevTools type declaration for TypeScript
declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION__?: any;
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: any;
  }
}

// Log the availability of Redux DevTools extension
if (typeof window !== 'undefined') {
  console.log('Redux DevTools extension available:', 
    !!window.__REDUX_DEVTOOLS_EXTENSION__ || !!window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__);
}

export const store = configureStore({
  reducer: {
    bookmarkCards: bookmarkCardsReducer,
    bookmarkFilter: bookmarkFilterReducer,
    bookmarkModal: bookmarkModalReducer,
    favouriteFilter: favouriteFilterReducer,
    language: languageReducer,
    loading: loadingReducer,
    messageQueue: messageQueueReducer,
    mobileView: mobileViewReducer,
    myFavourites: myFavouritesReducer,
    feedbackModal: feedbackModalReducer,
    showSiteFavOnly: showSiteFavOnlyReducer,
    siteFavourites: siteFavouritesReducer,
    user: userReducer,
    listLoader: listLoaderReducer,
    cardsLoader: cardsLoaderReducer,
  },
  // Always enable Redux DevTools in any environment
  devTools: {
    name: 'FCBookMarks',
    trace: true,
    traceLimit: 25,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});

// Log store creation success and configuration
console.log('Redux store created with the following configuration:',
  { 
    reducers: Object.keys(store.getState()),
    devToolsEnabled: true,
    devToolsConfig: { name: 'FCBookMarks', trace: true, traceLimit: 25 }
  }
);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Make store available on window for easier debugging
if (typeof window !== 'undefined') {
  (window as any).__reduxStore = store;
  console.log('Redux store attached to window.__reduxStore for debugging');
}

export default store;
